// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  height: 100%;
}
html,
body {
  margin: 0;
  padding: 0;
  min-height: 100%;
  min-width: 400px;
  padding-right: 0px !important;
}
#app {
  position: relative;
}
.scrollable-menu {
  height: auto;
  max-height: 400px;
  overflow-x: hidden;
}
.drop-zone {
  display: table;
}
.drop-zone .drop-text {
  display: none;
}
.drop-zone .preview-images {
  text-align: center;
  vertical-align: middle;
  display: table-cell;
}
.drop-zone .preview-images img {
  max-width: 100%;
  max-height: 200px;
}
.drop-zone.active .drop-text {
  display: block;
}
.drop-zone.reject .drop-text {
  display: block;
}
.drop-zone.active .preview-images {
  display: none;
}
.drop-zone.reject .preview-images {
  display: none;
}
.white-dropdown-button {
  background: #fff;
  cursor: pointer;
  padding: 5px 10px;
  border: 1px solid #ccc;
}
.with-optgroup .multiselect-container > li > a > label.radio,
.with-optgroup .multiselect-container > li > a > label.checkbox {
  text-indent: 20px;
}
.with-optgroup .multiselect-container > li > a.multiselect-all > label.radio,
.with-optgroup .multiselect-container > li > a.multiselect-all > label.checkbox {
  text-indent: 0px;
}
.with-optgroup .multiselect-container > li > a.multiselect-all > label.checkbox > input {
  position: relative;
}
.tile_count {
  margin-bottom: 0px;
  margin-top: 0px;
}
.tile_count .tile_stats_count {
  border: none !important;
  padding: 5px 8px !important;
}
span.count_top:empty:before,
div.count:empty:before {
  content: "\\200b";
}
.targeting-container {
  height: 300px;
  border: 1px solid #ddd;
}
.targeting-container > div {
  padding: 0;
}
.targeting-container > div,
.targeting-container > div > ul {
  height: 100%;
}
.targeting-container ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.targeting-container .targeting-categories li:hover,
.targeting-container .targeting-categories li.selected {
  background-color: #eee;
}
.targeting-container .targeting-categories li {
  padding: 5px;
  font-weight: 700;
  cursor: default;
}
.targeting-container .targeting-categories {
  border-right: 1px solid #ddd;
}
.targeting-container .targeting-items {
  border-right: 1px solid #ddd;
}
.targeting-container .targeting-selected > li > ul {
  margin-left: 20px;
}
.has-error .rw-dropdownlist {
  border-color: #a94442;
}
.campaign-listing .react-bs-table {
  border: none;
}
.campaign-listing .react-bs-container-body {
  overflow: visible;
}
.campaign-listing .table > tbody > tr:first-child > td {
  border: none;
}
.campaign-listing .table > tbody > tr > td {
  line-height: 20px;
}
.campaign-listing .table > tbody > tr > td div {
  text-transform: capitalize;
}
.campaign-listing .table > tbody > tr > td .sm-text {
  font-size: 11px;
}
.campaign-listing .table > tbody > tr > td a {
  color: #15c;
}
.no-margin {
  margin: 0;
}
.has-error .rw-multiselect {
  border-color: #a94442;
}
.fix-ms-glyph .form-control-feedback.glyphicon {
  line-height: 18px;
}
.react-bs-table > .react-bs-container-body > table > tbody > tr > td {
  white-space: normal;
}
.pb-mode .dropdown-toggle {
  background-color: #93a661 !important;
}
.pb-mode .dropdown-toggle:hover {
  background-color: #829356 !important;
}
.pb-mode .dropdown-toggle i,
.pb-mode .dropdown-toggle span {
  color: #fff !important;
}
.ifa-mode .dropdown-toggle {
  background-color: #1287a8 !important;
}
.ifa-mode .dropdown-toggle:hover {
  background-color: #107896 !important;
}
.ifa-mode .dropdown-toggle i,
.ifa-mode .dropdown-toggle span {
  color: #fff !important;
}
.adm-mode .dropdown-toggle {
  background-color: #f26d21 !important;
}
.adm-mode .dropdown-toggle:hover {
  background-color: #c2571a !important;
}
.adm-mode .dropdown-toggle i,
.adm-mode .dropdown-toggle span {
  color: #fff !important;
}
.nav-sm .active:hover ul.nav.child_menu {
  display: block;
}
.nav-sm .active:hover span.fa.fa-chevron-down {
  transform: rotate(-90deg);
}
.nav-sm span.fa.fa-chevron-down {
  position: absolute;
  top: 30px;
  right: 3px;
  line-height: 10px;
  margin: 0px;
  width: 10px;
  font-size: 10px;
}
.fix-dd .dropdown-menu {
  float: left;
  left: auto;
}
.wizard_steps .step-disabled .step_no {
  background-color: #ccc;
}
.wizard_steps .step-disabled .step_descr {
  color: #ccc;
}
.wizard_steps .step-disabled a {
  cursor: default;
}
button.chart-bar-btn.multiselect:hover,
.open button.chart-bar-btn.multiselect {
  border-bottom: 2px solid #48d1cc;
  box-shadow: none;
}
button.chart-line-btn.multiselect:hover,
.open button.chart-line-btn.multiselect {
  border-bottom: 2px solid #ed6922;
  box-shadow: none;
}
button.chart-interval-btn.multiselect:hover,
.open button.chart-interval-btn.multiselect {
  border-bottom: 2px solid #00a3ed;
  box-shadow: none;
}
button.chart-bar-btn.multiselect:before {
  content: "● ";
  line-height: 18px;
  font-size: 18px;
  color: #48d1cc;
}
button.chart-line-btn.multiselect:before {
  content: "● ";
  line-height: 18px;
  font-size: 18px;
  color: #ed6922;
}
button.chart-interval-btn.multiselect:before {
  content: "● ";
  line-height: 18px;
  font-size: 18px;
  color: #00a3ed;
}
button.chart-bar-btn.multiselect,
button.chart-line-btn.multiselect,
button.chart-interval-btn.multiselect {
  background-color: #ffffff;
  border: 0;
  border-bottom: 2px solid #ffffff;
}
.pac-container.pac-logo {
  z-index: 2000;
}
*.unselectable {
  -moz-user-select: -moz-none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.access-rights-panel .panel-body {
  padding: 15px 5px;
}
.refresh-stats-btn {
  margin-top: 5px;
}
ul.multiselect-container > li {
  max-width: 220px;
}
.multiselect-clear-filter {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./client/styles/main.less"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;AAEA;;EAEE,SAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;AAAF;AAGA;EACE,kBAAA;AADF;AAIA;EACE,YAAA;EACA,iBAAA;EACA,kBAAA;AAFF;AAKA;EACE,cAAA;AAHF;AAMA;EACE,aAAA;AAJF;AAOA;EACE,kBAAA;EACA,sBAAA;EACA,mBAAA;AALF;AAQA;EACE,eAAA;EACA,iBAAA;AANF;AAeA;EACE,cAAA;AAbF;AAgBA;EACE,cAAA;AAdF;AAiBA;EACE,aAAA;AAfF;AAkBA;EACE,aAAA;AAhBF;AAmBA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;AAjBF;AAoBA;;EAEE,iBAAA;AAlBF;AAqBA;;EAME,gBAAA;AAvBF;AA0BA;EAME,kBAAA;AA7BF;AAgCA;EACE,kBAAA;EACA,eAAA;AA9BF;AAiCA;EACE,uBAAA;EACA,2BAAA;AA/BF;AAkCA;;EAEE,gBAAA;AAhCF;AAmCA;EACE,aAAA;EACA,sBAAA;AAjCF;AAoCA;EACE,UAAA;AAlCF;AAqCA;;EAEE,YAAA;AAnCF;AAsCA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;AApCF;AAuCA;;EAEE,sBAAA;AArCF;AAwCA;EACE,YAAA;EACA,gBAAA;EACA,eAAA;AAtCF;AAyCA;EACE,4BAAA;AAvCF;AA0CA;EACE,4BAAA;AAxCF;AA8CA;EACE,iBAAA;AA5CF;AA+CA;EACE,qBAAA;AA7CF;AAmDA;EACE,YAAA;AAjDF;AAoDA;EACE,iBAAA;AAlDF;AAqDA;EACE,YAAA;AAnDF;AAsDA;EACE,iBAAA;AApDF;AAuDA;EACE,0BAAA;AArDF;AAwDA;EACE,eAAA;AAtDF;AAyDA;EACE,WAAA;AAvDF;AA0DA;EACE,SAAA;AAxDF;AA2DA;EACE,qBAAA;AAzDF;AA4DA;EACE,iBAAA;AA1DF;AA6DA;EACE,mBAAA;AA3DF;AA8DA;EACE,oCAAA;AA5DF;AA+DA;EACE,oCAAA;AA7DF;AAgEA;;EAEE,sBAAA;AA9DF;AAiEA;EACE,oCAAA;AA/DF;AAkEA;EACE,oCAAA;AAhEF;AAmEA;;EAEE,sBAAA;AAjEF;AAoEA;EACE,oCAAA;AAlEF;AAqEA;EACE,oCAAA;AAnEF;AAsEA;;EAEE,sBAAA;AApEF;AAwEA;EACE,cAAA;AAtEF;AAyEA;EACE,yBAAA;AAvEF;AA0EA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,iBAAA;EACA,WAAA;EACA,WAAA;EACA,eAAA;AAxEF;AA4EA;EACE,WAAA;EACA,UAAA;AA1EF;AA6EA;EACE,sBAAA;AA3EF;AA8EA;EACE,WAAA;AA5EF;AA+EA;EACE,eAAA;AA7EF;AAgFA;;EAEE,gCAAA;EACA,gBAAA;AA9EF;AAiFA;;EAEE,gCAAA;EACA,gBAAA;AA/EF;AAkFA;;EAEE,gCAAA;EACA,gBAAA;AAhFF;AAmFA;EACE,aAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;AAjFF;AAoFA;EACE,aAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;AAlFF;AAqFA;EACE,aAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;AAnFF;AAsFA;;;EAGE,yBAAA;EACA,SAAA;EACA,gCAAA;AApFF;AAwFA;EACE,aAAA;AAtFF;AAyFA;EACE,2BAAA;EACA,wBAAA;EACA,yBAAA;EACA,qBAAA;EACA,iBAAA;AAvFF;AA0FA;EACE,iBAAA;AAxFF;AA2FA;EACE,eAAA;AAzFF;AA8FA;EACE,gBAAA;AA5FF;AAkGA;EACE,aAAA;AAhGF","sourcesContent":["html {\n  height: 100%;\n}\n\nhtml,\nbody {\n  margin: 0;\n  padding: 0;\n  min-height: 100%;\n  min-width: 400px;\n  padding-right: 0px !important;\n}\n\n#app {\n  position: relative;\n}\n\n.scrollable-menu {\n  height: auto;\n  max-height: 400px;\n  overflow-x: hidden;\n}\n\n.drop-zone {\n  display: table;\n}\n\n.drop-zone .drop-text {\n  display: none;\n}\n\n.drop-zone .preview-images {\n  text-align: center;\n  vertical-align: middle;\n  display: table-cell;\n}\n\n.drop-zone .preview-images img {\n  max-width: 100%;\n  max-height: 200px;\n}\n\n.drop-zone.active {\n}\n\n.drop-zone.reject {\n}\n\n.drop-zone.active .drop-text {\n  display: block;\n}\n\n.drop-zone.reject .drop-text {\n  display: block;\n}\n\n.drop-zone.active .preview-images {\n  display: none;\n}\n\n.drop-zone.reject .preview-images {\n  display: none;\n}\n\n.white-dropdown-button {\n  background: #fff;\n  cursor: pointer;\n  padding: 5px 10px;\n  border: 1px solid #ccc;\n}\n\n.with-optgroup .multiselect-container > li > a > label.radio,\n.with-optgroup .multiselect-container > li > a > label.checkbox {\n  text-indent: 20px;\n}\n\n.with-optgroup .multiselect-container > li > a.multiselect-all > label.radio,\n.with-optgroup\n  .multiselect-container\n  > li\n  > a.multiselect-all\n  > label.checkbox {\n  text-indent: 0px;\n}\n\n.with-optgroup\n  .multiselect-container\n  > li\n  > a.multiselect-all\n  > label.checkbox\n  > input {\n  position: relative;\n}\n\n.tile_count {\n  margin-bottom: 0px;\n  margin-top: 0px;\n}\n\n.tile_count .tile_stats_count {\n  border: none !important;\n  padding: 5px 8px !important;\n}\n\nspan.count_top:empty:before,\ndiv.count:empty:before {\n  content: \"\\200b\"; // unicode zero width space character\n}\n\n.targeting-container {\n  height: 300px;\n  border: 1px solid #ddd;\n}\n\n.targeting-container > div {\n  padding: 0;\n}\n\n.targeting-container > div,\n.targeting-container > div > ul {\n  height: 100%;\n}\n\n.targeting-container ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.targeting-container .targeting-categories li:hover,\n.targeting-container .targeting-categories li.selected {\n  background-color: #eee;\n}\n\n.targeting-container .targeting-categories li {\n  padding: 5px;\n  font-weight: 700;\n  cursor: default;\n}\n\n.targeting-container .targeting-categories {\n  border-right: 1px solid #ddd;\n}\n\n.targeting-container .targeting-items {\n  border-right: 1px solid #ddd;\n}\n\n.targeting-container .targeting-selected {\n}\n\n.targeting-container .targeting-selected > li > ul {\n  margin-left: 20px;\n}\n\n.has-error .rw-dropdownlist {\n  border-color: #a94442;\n}\n\n.campaign-listing {\n}\n\n.campaign-listing .react-bs-table {\n  border: none;\n}\n\n.campaign-listing .react-bs-container-body {\n  overflow: visible;\n}\n\n.campaign-listing .table > tbody > tr:first-child > td {\n  border: none;\n}\n\n.campaign-listing .table > tbody > tr > td {\n  line-height: 20px;\n}\n\n.campaign-listing .table > tbody > tr > td div {\n  text-transform: capitalize;\n}\n\n.campaign-listing .table > tbody > tr > td .sm-text {\n  font-size: 11px;\n}\n\n.campaign-listing .table > tbody > tr > td a {\n  color: #15c;\n}\n\n.no-margin {\n  margin: 0;\n}\n\n.has-error .rw-multiselect {\n  border-color: #a94442;\n}\n\n.fix-ms-glyph .form-control-feedback.glyphicon {\n  line-height: 18px;\n}\n\n.react-bs-table > .react-bs-container-body > table > tbody > tr > td {\n  white-space: normal;\n}\n\n.pb-mode .dropdown-toggle {\n  background-color: #93a661 !important;\n}\n\n.pb-mode .dropdown-toggle:hover {\n  background-color: #829356 !important;\n}\n\n.pb-mode .dropdown-toggle i,\n.pb-mode .dropdown-toggle span {\n  color: #fff !important;\n}\n\n.ifa-mode .dropdown-toggle {\n  background-color: #1287a8 !important;\n}\n\n.ifa-mode .dropdown-toggle:hover {\n  background-color: #107896 !important;\n}\n\n.ifa-mode .dropdown-toggle i,\n.ifa-mode .dropdown-toggle span {\n  color: #fff !important;\n}\n\n.adm-mode .dropdown-toggle {\n  background-color: #f26d21 !important;\n}\n\n.adm-mode .dropdown-toggle:hover {\n  background-color: #c2571a !important;\n}\n\n.adm-mode .dropdown-toggle i,\n.adm-mode .dropdown-toggle span {\n  color: #fff !important;\n}\n\n//Making submenu display on hover for the small sidebar\n.nav-sm .active:hover ul.nav.child_menu {\n  display: block;\n}\n\n.nav-sm .active:hover span.fa.fa-chevron-down {\n  transform: rotate(-90deg);\n}\n\n.nav-sm span.fa.fa-chevron-down {\n  position: absolute;\n  top: 30px;\n  right: 3px;\n  line-height: 10px;\n  margin: 0px;\n  width: 10px;\n  font-size: 10px;\n}\n\n//Fix dropdown menu not aligning right\n.fix-dd .dropdown-menu {\n  float: left;\n  left: auto;\n}\n\n.wizard_steps .step-disabled .step_no {\n  background-color: #ccc;\n}\n\n.wizard_steps .step-disabled .step_descr {\n  color: #ccc;\n}\n\n.wizard_steps .step-disabled a {\n  cursor: default;\n}\n\nbutton.chart-bar-btn.multiselect:hover,\n.open button.chart-bar-btn.multiselect {\n  border-bottom: 2px solid #48d1cc;\n  box-shadow: none;\n}\n\nbutton.chart-line-btn.multiselect:hover,\n.open button.chart-line-btn.multiselect {\n  border-bottom: 2px solid #ed6922;\n  box-shadow: none;\n}\n\nbutton.chart-interval-btn.multiselect:hover,\n.open button.chart-interval-btn.multiselect {\n  border-bottom: 2px solid #00a3ed;\n  box-shadow: none;\n}\n\nbutton.chart-bar-btn.multiselect:before {\n  content: \"● \";\n  line-height: 18px;\n  font-size: 18px;\n  color: #48d1cc;\n}\n\nbutton.chart-line-btn.multiselect:before {\n  content: \"● \";\n  line-height: 18px;\n  font-size: 18px;\n  color: #ed6922;\n}\n\nbutton.chart-interval-btn.multiselect:before {\n  content: \"● \";\n  line-height: 18px;\n  font-size: 18px;\n  color: #00a3ed;\n}\n\nbutton.chart-bar-btn.multiselect,\nbutton.chart-line-btn.multiselect,\nbutton.chart-interval-btn.multiselect {\n  background-color: #ffffff;\n  border: 0;\n  border-bottom: 2px solid #ffffff;\n}\n\n//Google maps dropdown\n.pac-container.pac-logo {\n  z-index: 2000;\n}\n\n*.unselectable {\n  -moz-user-select: -moz-none;\n  -khtml-user-select: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.access-rights-panel .panel-body {\n  padding: 15px 5px;\n}\n\n.refresh-stats-btn {\n  margin-top: 5px;\n}\n\n//*** native components overides\n//bootstrap-react-multiselect\nul.multiselect-container > li {\n  max-width: 220px;\n}\n\n.multiselect-item.multiselect-filter {\n}\n\n.multiselect-clear-filter {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
